export const AIAgentLSKey = 'AIAgentLSKey'
